module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "p-404 u-absolute u-pos-tl u-fit-w u-viewport-fit-h u-flex u-flex-ai--center u-flex-jc--center u-bg--black"
  }, [_c('div', {
    staticClass: "p-404__wrapper u-zindex--1"
  }, [_c('h2', {
    staticClass: "p-404__title t-ffamily--simplon t-fweight--light u-align-center u-color--brand-primary"
  }, [_vm._v("404")]), _vm._v(" "), _c('div', {
    staticClass: "p-404__description u-marg-x-auto u-color--white u-opacity--50 u-lheight--150p u-align-center"
  }, [_vm._v("The page you're looking for doesn't exist")]), _vm._v(" "), _c('div', {
    staticClass: "p-404__button-container u-align-center"
  }, [_c('app-button', {
    staticClass: "p-presale__header-container__contribute-container__button is-white u-inline-block u-uppercase t-fsize--xs t-weight--bold",
    attrs: {
      "to": _vm.CONFIG.pages.home.path
    }
  }, [_vm._v("\n                Back home\n            ")])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-04b8b542"}!./src/scripts/components/page-404/template.html
// module id = 450
// module chunks = 0